(function(){
  function init(root){
    root.querySelectorAll('.site-header .nav-dropdown').forEach(function(dropdown){
      if(dropdown.dataset.hmMenuReady)return;
      dropdown.dataset.hmMenuReady='true';
      let timer;
      dropdown.querySelector('summary').addEventListener('click',function(event){
        if(event.detail>0&&event.pointerType!=='touch'&&window.matchMedia('(min-width:1201px) and (hover:hover)').matches){event.preventDefault();dropdown.open=true;}
      });
      dropdown.addEventListener('toggle',function(){
        if(dropdown.open)document.querySelectorAll('.site-header .nav-dropdown[open]').forEach(function(other){if(other!==dropdown)other.open=false;});
      });
      dropdown.addEventListener('pointerenter',function(event){
        if(event.pointerType==='touch'||!window.matchMedia('(min-width:1201px) and (hover:hover)').matches)return;
        clearTimeout(timer);dropdown.open=true;
      });
      dropdown.addEventListener('pointerleave',function(event){
        if(event.pointerType==='touch')return;
        timer=setTimeout(function(){if(!dropdown.contains(document.activeElement))dropdown.open=false;},180);
      });
      dropdown.addEventListener('focusout',function(event){if(!dropdown.contains(event.relatedTarget))dropdown.open=false;});
      dropdown.addEventListener('keydown',function(event){if(event.key==='Escape'&&dropdown.open){dropdown.open=false;dropdown.querySelector('summary').focus();event.stopPropagation();}});
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();
